import { Application } from '@hotwired/stimulus';

const EezyStimulusApplication = {
  loadedControllers: [],
  application: Application.start(),
  register(identifier, controller) {
    // if a controller was already registered, do not re-register.
    if (this.loadedControllers.includes(identifier)) return;

    this.application.register(identifier, controller);
    // keep directory of registered controllers.
    this.loadedControllers.push(identifier);
  },
};

export default EezyStimulusApplication;
